'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface VariantsTableSkeletonProps {
    rows?: number
}

export const VariantsTableSkeleton = ({ rows = 10 }: VariantsTableSkeletonProps) => (
    <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
        <>
            {Array.from({ length: rows }, (_, index) => (
                <TableRow key={index}>
                    <TableCell className="w-10">
                        <Skeleton height={16} width={16} />
                    </TableCell>

                    <TableCell className="w-16">
                        <Skeleton height={40} width={40} borderRadius="0.25rem" />
                    </TableCell>

                    <TableCell>
                        <div className="space-y-1">
                            <Skeleton height={16} width={180} />
                            <Skeleton height={12} width={120} />
                        </div>
                    </TableCell>

                    <TableCell className="w-32">
                        <Skeleton height={16} width={80} />
                    </TableCell>

                    <TableCell className="w-32 text-right">
                        <div className="space-y-1">
                            <Skeleton height={16} width={60} />
                            <Skeleton height={10} width={80} />
                        </div>
                    </TableCell>

                    <TableCell className="w-24">
                        <Skeleton height={16} width={60} />
                    </TableCell>

                    <TableCell className="w-24">
                        <Skeleton height={20} width={70} borderRadius="0.375rem" />
                    </TableCell>

                    <TableCell className="w-20">
                        <Skeleton height={20} width={60} borderRadius="0.375rem" />
                    </TableCell>
                </TableRow>
            ))}
        </>
    </SkeletonTheme>
)

